const CashIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 5C2.44772 5 2 5.44772 2 6V18C2 18.5523 2.44772 19 3 19H21C21.5523 19 22 18.5523 22 18V6C22 5.44772 21.5523 5 21 5H3ZM20 11C18.8954 11 18 11.8954 18 13C18 14.1046 18.8954 15 20 15V17H4V15C5.10457 15 6 14.1046 6 13C6 11.8954 5.10457 11 4 11V7H20V11ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z" />
  </svg>
);

export default CashIcon;
